import state from './equipmentsState'
import mutations from './equipmentsMutations'
import actions from './equipmentsActions'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
}
